

console.log ('helloo!!!');

const artImages = document.querySelectorAll('.art-item, .kg-image-card, .kg-gallery-image');

for (let i = 0; i < artImages.length; i++){
    artImages[i].addEventListener('click', () => {
        const opened = artImages[i].classList.toggle('expanded');

        // The wrapper is reused, so it keeps the scroll position from last time.
        if (opened) {
            artImages[i].scrollTop = 0;
        }
    });
} 